/* eslint-disable import/extensions */
/* eslint-disable import/no-unresolved */
/* eslint-disable import/first */
/* eslint-disable no-undef */
import Vue from 'vue';
import App from './app.vue';
import router from './router';
import store from './store';

import AxfUI from 'axf-ui';
import ElementUI, { Loading } from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import 'axf-ui/lib/theme/index.css';
import VeLine from 'v-charts/lib/line.common';
import VePie from 'v-charts/lib/pie.common';
import vueFilters from './filters';
// import axf from 'axf-polyfill';
// 额外定制内容
import CustomConstant from '@/js/utils/constant';
import DeleteDialog from '@/components/DeleteDialog.vue';
import operationHTTP from '@/js/utils/operationHTTP';
import PromptTextDialog from '@/components/PromptTextDialog.vue';
import FormErrorPanel from './components/FormErrorPanel';
import errCode from '@/js/utils/axinfu_error_code';
import './js/utils/closure.js';
// import ATable from '../../epay-components/packages/Table/src/main';

// Vue.component('a-table', ATable);
let loadingInstance = '';

// axf前端公用组件
const root = document.createElement('div');
document.body.appendChild(root);

// 前端公共变量集合
require('./global/common-dialog.css');
require('./global/common.less');
require('./global');

axf.config({
	base: '/epay',
	apiEndpoint: '/epay/api',
	fetchErrorAutoReload: false,
	fetchErrorTimeoutAutoReloadText: '亲，网络开小差了，请点击ok刷新哦！',
	logOutUrl: '/logout',
});

// node包引用
Vue.use(ElementUI);
Vue.use(AxfUI);
vueFilters(Vue);
/**
	 * 全局注册
	 * v-charts-组件
	 */
Vue.component('ve-line', VeLine);
Vue.component('ve-pie', VePie);
/**
	 * 全局注册
	 * v-charts-组件
	 */
Vue.component('ve-line', VeLine);
Vue.component('ve-pie', VePie);
Vue.prototype.$errCode = errCode;
/**
 * 全局注册
 * 提示文字类弹框-组件
 */
Vue.component('text-dialog', PromptTextDialog);

/**
 * 全局注册
 * 删除类弹框-组件
 */
Vue.component('delete-dialog', DeleteDialog);

/**
	 * 全局注册
	 * v-charts-组件
	 */
Vue.component('ve-line', VeLine);
Vue.component('ve-pie', VePie);
Vue.prototype.$errCode = errCode;
/**
 * 显示成功Toast
 * @param text
 */
Vue.prototype.$showSuccessMsg = function (text) {
	this.$message({
		message: text,
		type: 'success',
	});
};
/**
 * 全局注册
 * 提示文字类弹框-组件
 */
Vue.component('text-dialog', PromptTextDialog);
/**
 * 全局注册
 * 删除类弹框-组件
 */
Vue.component('delete-dialog', DeleteDialog);

Vue.prototype.$axf = axf;

Vue.prototype.$formMethods = {
	/**
	 * 收集表单验证的错误信息并返回数组
	 * @params prop
	 */
	collectError: (prop) => {
		const errorArr = [];
		if (prop) {
			for (const item in prop) {
				for (let i = 0; i < prop[item].length; i++) {
					errorArr.push(prop[item][i].message);
				}
			}
		}
		return errorArr;
	},
};

/**
 * 显示失败Toast
 * @param text
 */
Vue.prototype.$showFailureMsg = function (text) {
	this.$message.error(text);
};
/**
 * 显示全屏加载
 */
Vue.prototype.$showFullLoading = function () {
	if (loadingInstance) {
		loadingInstance.close();
	}
	loadingInstance = Loading.service({
		fullscreen: true,
	});
};

Vue.prototype.$EventBus = new Vue();

/**
 * 关闭全屏loading
 */
Vue.prototype.$closeFullLoading = function () {
	loadingInstance.close();
};
/**
 * 显示加载loading
 */
Vue.prototype.$showViewLoading = function () {
	if (loadingInstance) {
		loadingInstance.close();
	}
	loadingInstance = Loading.service({
		target: 'body',
		// lock: true,
		// text: 'Loading',
		spinner: 'el-icon-loading',
		background: 'rgba(255, 255, 255, 0)',
	});
};

Vue.prototype.$CustomConstant = CustomConstant;

Vue.component('delete-dialog', DeleteDialog);
Vue.component('text-dialog', PromptTextDialog);
Vue.component('form-error-panel', FormErrorPanel);

/**
 * 显示加载loading
 */
Vue.prototype.$showViewLoading = function () {
	if (loadingInstance) {
		loadingInstance.close();
	}
	loadingInstance = Loading.service({
		target: '#main-view-body',
		spinner: 'axf-icon-loading',
		background: 'rgba(255, 255, 255, 0)',
	});
};

/**
 * 关闭加载loading
 */
Vue.prototype.$closeViewLoading = function () {
	loadingInstance.close();
};

/**
 * 显示右测面板Loading
 */
Vue.prototype.$showPanelLoading = function () {
	if (loadingInstance) {
		loadingInstance.close();
	}
	loadingInstance = Loading.service({
		target: '#panel-content',
		spinner: 'axf-icon-loading',
		background: 'rgba(255, 255, 255, 0)',
	});
};

/**
 * 关闭右侧面板Loading
 */
Vue.prototype.$closePanelLoading = function () {
	loadingInstance.close();
};

/**
 * 显示全屏加载
 */
Vue.prototype.$showFullLoading = function () {
	if (loadingInstance) {
		loadingInstance.close();
	}
	loadingInstance = Loading.service({
		fullscreen: true,
		spinner: 'axf-icon-loading',
		background: 'rgba(255, 255, 255, 0)',
	});
};

/**
 * 关闭全屏loading
 */
Vue.prototype.$closeFullLoading = function () {
	loadingInstance.close();
};
Vue.filter('jeFormat', (value) => {
	let str = value;
	let returnStr;
	if (typeof str !== 'string') {
		str = String(str);
	}
	const regex = /\B(?=(\d{3})+(?!\d))/g;
	if (str.indexOf('.') == -1) {
		returnStr = `${str.replace(regex, ',')}.00`;
	} else {
		const newStr = str.split('.');
		returnStr = newStr[0].replace(regex, ',');

		if (newStr[1].length <= 1) {
			// 小数点后只有一位时
			returnStr = `${returnStr}.${newStr[1]}0`;
		} else if (newStr[1].length > 1) {
			// 小数点后两位以上时
			const decimals = newStr[1].substr(0, 2);
			returnStr = `${returnStr}.${decimals}`;
		}
	}
	return returnStr;
});

axf.config({
	base: '/epay',
	apiEndpoint: '/epay/api',
	fetchErrorAutoReload: false,
	fetchErrorTimeoutAutoReloadText: '亲，网络开小差了，请点击ok刷新哦！',
});
(async function () {
	await operationHTTP
		.getClientConfHttp()
		.then((confData) => {
			window.$fromServerConstant = confData;
			Vue.prototype.$fromServerConstant = confData;
		})
		.catch((e) => {
			console.log(e);
		});
}());
new Vue({
	store,
	router,
	render: h => h(App),
}).$mount(root);
